<template>
  <div :class="{'items-wrap': true, 'px-4': $vuetify.breakpoint.mdAndUp}" v-if="showList">
    <v-flex xs12 mb-3 :mt-5="width < 960" :pt-5="width < 960">
      <template v-for="(category, index) in itemsList">
        <v-flex xs12 mb-3 :mt-5="index !== 0" :key="index+10000" v-if="isImage(category, 'webpage-itemlist-banner')">
          <v-img contain
                 class="imageBannerClass"
                 :src="env === 'development' ? `/api/imageresource/${category.images.find(x => x.label === 'webpage-itemlist-banner').value}`
                : `/webshopplanet/imageresource/${category.images.find(x => x.label === 'webpage-itemlist-banner').value}`">
          </v-img>
        </v-flex>
        <v-flex xs12 :id="'abc-'+category.itemId" :key="index" class="text-xs-center" :mt-5="!isImage(category, 'webpage-itemlist-banner') && index !== 0">
          <v-layout row wrap justify-center>
            <h1 style="font-weight: 400">
              {{ category.name[$lang.current_lang] ? category.name[$lang.current_lang] : category.name.en }}
            </h1>
          </v-layout>
          <v-layout row wrap justify-center v-if="category.desc && category.desc[$route.params.lang]">
            <h4 v-if="category.desc && category.desc[$route.params.lang]"
                style="font-weight: 400">{{ category.desc[$route.params.lang] }}</h4>
          </v-layout>
          <div class="items-list mt-3 px-3" :id="'cba-'+index">
            <MenuItems :env="env" :items="category.items" :nested="false"/>
          </div>
        </v-flex>
      </template>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Order from '@/components/webshop/modals/Order';

export default {
  props: ['itemsList'],
  data: () => ({
    search: null,
    dialog: false,
    item: null,
    companyId: null,
    env: 'null',
    panel: [],
    showList: false,
  }),
  components: {
    Order,
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$store.dispatch('blockScroll', true);
      } else {
        this.$store.dispatch('blockScroll', false);
      }
    },
  },
  computed: {
    ...mapGetters({
      itemsInSingleList: 'itemsList',
      categories: 'categories',
      company: 'company',
      width: 'width',
    }),
    formattedItemsList() {
      const returnArray = [];
      const returnFunct = (item) => {
        returnArray.push(this.returnSearchArray(item));
        if (item.items && item.items.length > 0) {
          item.items.forEach(x => returnFunct(x));
        }
      };
      this.itemsInSingleList.forEach(y => returnFunct(y));
      return returnArray.filter(element => element !== undefined);
    },
  },
  created() {
    this.companyId = localStorage.getItem('webShopResourceId');
    this.env = process.env.NODE_ENV;
    this.panel = Object.keys(this.itemsList)
      .map(() => null);
    this.panel[0] = 0;
    this.showList = true;
  },
  methods: {
    isImage(item, label) {
      if (item.images) {
        return item.images.filter(x => x.label === label).length > 0;
      }
      return false;
    },
    scrollToHeader(index) {
      const element = document.getElementById(`abc-${index}`);
      const elementPosition = element.getBoundingClientRect().top;
      const bodyRect = document.body.getBoundingClientRect();
      const offset = elementPosition - bodyRect.top;
      setTimeout(() => {
        window.scrollTo({
          top: offset - 60,
          behavior: 'smooth',
        });
      }, 125);
    },
  },
};
</script>

<style lang="scss" scoped>
html {
  scroll-behavior: smooth !important;
}

.items-wrap {
  @media only screen and (max-width: 600px) {
    padding: 0;
  }
}

.items-list {
  max-height: unset !important;
}

li {
  background: transparent !important;
}

.hidden {
  display: none;
  opacity: 0;
  transition: ease-in all 0.5s;
}

.header {
  font-weight: 700;
  font-size: 16px;
}

.animation {
  opacity: 1;
  transition: ease-in all 0.5s;
}

.imageIconClass {
  min-width: 50px;
  max-width: 50px;
  max-height: 50px;
  border-radius: 3px;
}

.imageBannerClass {
  border-radius: 3px;
  max-height: 200px;
}

</style>



// WEBPACK FOOTER //
// src/components/webshop/MenuCategories.vue